// extracted by mini-css-extract-plugin
export default {"adminReview":"AdminReview_adminReview__gy4zB","approve":"AdminReview_approve__z+wm4","reject":"AdminReview_reject__LJosU"};